<template>
    <div>
        <Modal v-model="showCreateTesk" :mask-closable="false" :closable="false" title="创建任务">
            <Form ref="createformTesk" :label-width="80" :model="form" :rules="rule">
                <FormItem label="任务来源" prop="taskSource">
                    <Select v-model="form.taskSource">
                        <Option :value="1">客户</Option>
                        <Option :value="2">生产商</Option>
                    </Select>
                </FormItem>
                <FormItem label="售后类型" v-if="form.taskSource == 1" prop="shType">
                    <Select v-model="form.shType">
                        <Option v-for="item in c售后类型List" :value="item.value" :key="item.value">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="任务描述" prop="taskExplain">
                    <!-- <DatePicker type="date" v-model="form.c计划完成时间" placeholder="请选择" style="width: 100%" /> -->
                    <Input v-model="form.taskExplain" :maxlength="100" show-word-limit type="textarea" placeholder="请输入" />
                </FormItem>
                <FormItem>
                    <Upload
                        multiple
                        ref="up"
                        :action="$constDefinition.baseUrl + '/file/UploadBySceneDataTaskFile'"
                        :max-size="10240"
                        accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.GIF,.PNG,.EXCEL,.WORD,.PDF,.excel,.excl,.xlsx,.xls,.word,.docx,.pdf,.doc"
                        :on-success="upsucc"
                        :before-upload="upbefore"
                        :on-remove="refile"
                    >
                        <Button icon="ios-cloud-upload-outline">上传文件</Button>
                    </Upload>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancel" class="close-btn">取消</Button>
                <Button @click="ok" type="primary" class="close-btn">提交</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import { getAfterSaleType, createTest } from '../../../api/index';
export default {
    props: {
        showCreateTesk: {
            type: Boolean,
            required: true,
            default: false,
        },
        guid: {
            type: Array,
            required: true,
            default: [],
        },
    },
    data() {
        return {
            c售后类型List: [],
            form: {
                sceneDataItemGuId: '',
                taskSource: 1,
                shType: 0,
                taskExplain: '',
                sceneDataTaskFilesList: [], //附件
            },
            fileNum: 0,
            rule: {
                taskSource: [{ required: true, message: '请输入', trigger: 'blur', type: 'number' }],
                shType: [{ required: true, message: '请输入', trigger: 'blur', type: 'number' }],
                taskExplain: [{ required: true, message: '请输入', trigger: 'blur', type: 'string' }],
            },
        };
    },

    mounted() {
        this.getAfterSaleType();
    },
    methods: {
        //文件上传之前
        upbefore() {
            this.fileNum++;
        },
        //文件上传成功
        upsucc(response, file, fileList) {
            this.form.sceneDataTaskFilesList.push({ fileGuids: response.result.guid });

            //    {
            //   "fileGuids": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            //   "fileName": "string",
            //   "url": "string"
            // }
        },
        //移除文件
        refile(file, fileList) {
            console.log('🚀 ~ file: createTesk.vue:76 ~ refile ~ file, fileList', file, fileList);
            this.fileNum--;
            for (let index = 0; index < this.form.sceneDataTaskFilesList.length; index++) {
                if (this.form.sceneDataTaskFilesList[index].fileGuids == file.response.result.guid) {
                    this.form.sceneDataTaskFilesList.splice(index, 1);
                }
            }
        },
        ok() {
            let _this = this;
            this.$refs['createformTesk'].validate(async (valid) => {
                if (valid) {
                    if (this.guid.length > 0) {
                        this.form.sceneDataItemGuId = this.guid[0];
                    } else {
                        return;
                    }
                    //判断文件上传完成
                    if (_this.fileNum != this.form.sceneDataTaskFilesList.length) {
                        this.$Message.error({content:'文件正在上传，请稍后',duration:3,});
                        
                       return;
                    }
                    await createTest(_this.form);
                    this.$Message.success({content:'添加成功',duration:3,});
                    this.$refs['createformTesk'].resetFields();
                    this.$parent.closeShowAfterSale();
                    this.$parent.getpage();
                    this.clearForm();
                } else {
                }
            });
        },
        clearForm() {
            this.form = {
                sceneDataItemGuId: '',
                taskSource: 1,
                shType: 0,
                taskExplain: '',
                sceneDataTaskFilesList: [], //附件
            };
            this.fileNum = 0;
            this.$refs['up'].clearFiles();
        },
        cancel() {
            this.$refs['createformTesk'].resetFields();
            this.$parent.closeShowAfterSale();
            this.clearForm();
        },
        async getAfterSaleType() {
            const { data } = await getAfterSaleType();
            //  console.log("🚀 ~ file: createSale.vue:84 ~ getAfterSaleType ~ data", data)
            this.c售后类型List = data.result.statusList;
            console.log('🚀 ~ file: createSale.vue:88 ~ getAfterSaleType ~ this.c售后类型List', this.c售后类型List);
        },
    },
};
</script>
